export const common = {
  appName: "سامي عبدالسلام",
  welcome: "مرحباً بك",
  continue: "متابعة",
  back: "رجوع",
  next: "التالي",
  cancel: "إلغاء",
  confirm: "تأكيد",
  save: "حفظ",
  search: "بحث",
  loading: "جاري التحميل...",
  error: "حدث خطأ",
  success: "تم بنجاح",
  retry: "إعادة المحاولة",
  close: "إغلاق",
  edit: "تعديل",
  delete: "حذف",
  submit: "إرسال",
  login: "تسجيل الدخول",
  register: "إنشاء حساب",
  logout: "تسجيل الخروج",
  profile: "الملف الشخصي",
  settings: "الإعدادات",
  notifications: "الإشعارات",
  help: "المساعدة",
  contact: "تواصل معنا",
  privacy: "الخصوصية",
  terms: "الشروط والأحكام"
};